<template>
  <div>
    <div class="add">
      <b-button
        variant="primary"
        class="navbar-brn-primary"
        v-b-modal="'modal-tekshiruvlar'"
      >
        Дори дармонлар
      </b-button>
      <b-button
        @click="pechat"
        variant="primary"
        class="navbar-brn-primary ml-2"
      >
        <b-icon icon="printer-fill"></b-icon>
        {{ "Печать" }}
      </b-button>
      <b-button
        v-if="!$store.state.kasTar"
        class="navbarBtnTashxis"
        style="margin-left: 10px;"
        @click="Arrow"
        variant="primary"
      >
        <b-icon icon="arrow90deg-right"></b-icon>
      </b-button>
      <b-modal :id="'modal-tekshiruvlar'" title="" size="xl" hide-footer>
        <table class="table table-sm table-bordered">
          <thead id="head">
            <tr>
              <th style="width: 30px;">№</th>
              <th style="width: 150px;">Манбъа</th>
              <th>Дори</th>
              <th style="width: 230px;">Изоҳ</th>
              <th style="width: 70px;">Мавжут</th>
              <th style="width: 100px;">Вақт</th>
              <th style="width: 50px;">Кун</th>
              <th style="width: 50px;">Маҳал</th>
              <th style="width: 50px;">Сони</th>
              <th style="width: 40px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in madalData" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <v-select
                  :options="reagent_type"
                  label="name"
                  :components="{ Deselect }"
                  @input="chageReagent(item, index)"
                  :reduce="option => option"
                  v-model="item.reagent_type"
                />
              </td>
              <td>
                <div style="position: relative;">
                  <v-select
                    :options="reagentList"
                    label="name"
                    @input="chageReagent(item, index)"
                    :reduce="option => option"
                    v-model="item.reagent"
                  />
                  <button
                    class="dori-add-btn-muolaja"
                    v-b-modal="'DorilarModal-drug' + index + modalIdCom"
                  >
                    ...
                  </button>
                </div>
                <b-modal
                  :id="'DorilarModal-drug' + index + modalIdCom"
                  title="Дори қўшиш"
                  hide-footer
                >
                  <div class="md-layout-item md-small-size-100 md-size-100">
                    <span class="shirift">
                      {{ $t("Дори номи") }}
                    </span>
                    <b-input
                      id="dorilar-name"
                      style="background: #fff; border: 1px solid #ced4da;"
                      type="text"
                      v-model="DorilarQoshish.name"
                    />
                  </div>
                  <div class="CreateName">
                    <b-button
                      class="modalBtn1"
                      size="sm"
                      style="height: 37px;"
                      variant="danger "
                      @click="DoriClose(index)"
                    >
                      <b-icon icon="calendar2-x"></b-icon>
                      {{ $t("Бекор қилиш") }}
                    </b-button>
                    <b-button
                      class="mt-3 ml-2 modalBtn"
                      @click="DoriSaqlash(index)"
                      variant="success"
                    >
                      <b-icon icon="calendar2-plus"></b-icon>
                      {{ $t("Сақлаш") }}
                    </b-button>
                  </div>
                </b-modal>
              </td>
              <td>
                <input
                  type="text"
                  v-model="item.comment"
                  style="width: 100%; border: 1px solid #ccc; font-size: 12pt; border-radius: 5px; padding: 3px 0;"
                />
              </td>
              <td style="text-align: center;">
                {{ item.ost | numFormat }}
              </td>
              <td>
                <input
                  type="date"
                  v-model="item.date"
                  style="width: 115px; border: 1px solid #ccc; font-size: 13pt; border-radius: 5px;"
                />
              </td>
              <td>
                <vue-numeric
                  class="numberic-style"
                  separator="space"
                  v-bind:minus="false"
                  v-model="item.day"
                ></vue-numeric>
              </td>
              <td>
                <vue-numeric
                  class="numberic-style"
                  separator="space"
                  v-bind:minus="false"
                  v-model="item.time"
                ></vue-numeric>
              </td>
              <td>
                <vue-numeric
                  class="numberic-style"
                  separator="space"
                  v-bind:minus="false"
                  :precision="2"
                  v-model="item.count"
                ></vue-numeric>
              </td>
              <td>
                <b-button
                  style="width: 30px; height: 30px; display: flex; justify-content: center;"
                  variant="outline-danger"
                  @click="removeRow(index)"
                >
                  <b-icon style="width: 17px;" icon="trash"></b-icon>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>

        <b-button
          class="qoshish_Btn_"
          variant="primary"
          type="number"
          @click="madalDataAdd"
        >
          <b-icon icon="plus" font-scale="2" color="#fff"></b-icon>
        </b-button>
        <div class="CreateName">
          <b-button
            class="modalBtn1"
            size="sm"
            style="height: 37px;"
            variant="danger "
            @click="Close"
          >
            <b-icon icon="calendar2-x"></b-icon>
            {{ $t("Бекор қилиш") }}
          </b-button>
          <b-button
            class="mt-3 ml-2 modalBtn"
            @click="tasdiqlash"
            variant="success"
          >
            <b-icon icon="calendar2-plus"></b-icon>
            {{ "Тасдиқлаш" }}
          </b-button>
        </div>
      </b-modal>
    </div>
    <!-- <div class="add">
        <b-button type="submit" @click="addRow" variant="info" class="btn">Қатор қўшиш</b-button>
        <b-button type="submit" @click="addColumn" variant="info" class="btn">Устун қўъшиш</b-button>
    </div> -->
    <table border="1px solid black" v-if="reg_drug.length" class="shablo_table">
      <thead style="text-align: center;">
        <tr>
          <th style="width: 2%; height: 130px;">№</th>
          <th style="width: 250px;">Dori darmonlar</th>
          <th style="width: 150px;">Manbaa</th>
          <th style="width: 200px;">Izoh</th>
          <th v-for="item in days" style="width: 80px !important;">
            <div class="card_month">
              {{ item }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr style="height: 30px;" v-for="(item, index) in trDatas" :key="index">
          <td>{{ index + 1 }}</td>
          <td>
            {{ item.name }}
          </td>
          <td>
            {{ item.reagent_type ? item.reagent_type.name : '' }}
          </td>
          <td>
            {{ item.comment }}
          </td>
          <td style="padding: 0px !important;" v-for="itemTd in days">
            <div
              v-if="
                reg_drug.map(
                  rd =>
                    rd.reagent.id == item.id && rd.date == itemTd && !rd.deleted
                )
              "
            >
              <div
                v-for="(rd, idx) in reg_drug"
                v-if="
                  rd.reagent.id == item.id && rd.date == itemTd && !rd.deleted
                "
                :key="idx"
              >
                <b-button
                  v-if="
                    localUser.role == 'Admin' || localUser.role == 'Shifokor'
                  "
                  style="width: 27px; height: 27px; display: flex; justify-content: center; border-radius: 50%; float: right;"
                  variant="outline-danger"
                  @click="deleteDrug(rd, idx)"
                >
                  <b-icon style="width: 12px;" icon="trash"></b-icon>
                </b-button>
                <input
                  v-for="itemch in rd.time_change"
                  :disabled="Math.floor(new Date().setHours(0, 0, 0, 0,) / 1000) > itemch.date_time && itemch.change"
                  @change="itemch.user_id = localUser.id, timeChage(rd, idx)"
                  v-model="itemch.change"
                  type="checkbox"
                />
              </div>
            </div>
            <div v-else>
              <div style="height: 30px;"></div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["bemorInfo", "registration_drug", "trDatas", "days", "modalIdCom"],
  data() {
    return {
      formattedDate: "",
      reagent_type: [],
      Deselect: {
        render: createElement => createElement("span", "")
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      DorilarQoshish: {
        name: "",
        status: "",
        type: "pill"
      },
      manba: [],
      month: null,
      reagentList: [],
      reg_drug: this.registration_drug,
      madalData: []
      // trDatas: [],
      // days: []
    };
  },
  mounted() {
    // this.tasdiqlash();
    this.getReagent();
    this.reagentType();
  },
  watch: {
    registration_drug(newValue) {
      if (newValue) {
        this.reg_drug = newValue;
      }
    }
  },
  methods: {
    Arrow() {
      let data = "";
      this.trDatas.forEach(el => {
        data += `${el.name}: (${el.comment}),`;
      });
      if (data) {
        this.$store.state.ArrowData = {
          name: "Olgan muolajalari",
          category: "",
          value: data
        };
        this.$bvToast.toast(this.$t("Малумотлар қўшилди"), {
          title: this.$t("Огоҳлантириш"),
          autoHideDelay: 2000,
          appendToast: true,
          variant: "success"
        });
      }
    },
    timeChage(item, index) {
      console.log(item, index)
    },
    DoriSaqlash(index) {
      let self = this;
      axios({
        method: "post",
        url: "/reagent/create",
        data: self.DorilarQoshish
      }).then(data => {
        if (data) {
          self.madalData[index].reagent = data.data.data;
          self.$bvModal.hide(
            `${"DorilarModal-drug" + index + self.modalIdCom}`
          );
          self.getReagent();
          self.DorilarQoshish.name = "";
        }
      });
    },
    DoriClose(index) {
      this.DorilarQoshish.name = "";
      this.$bvModal.hide(`${"DorilarModal-drug" + index + this.modalIdCom}`);
    },
    chageReagent(item, index) {
      let self = this;
      item.reagent_type_id = item.reagent_type.id
      if (item.reagent_type.id && item.reagent) {
        axios({
          method: "post",
          url: "registration/reagent_ost",
          data: {
            reagent_id: item.reagent.id,
            reagent_type_id: item.reagent_type.id
          }
        }).then(res => {
          item.ost = res.data.ost;
          item.price = res.data.price;
        });
      }
    },
    reagentType() {
      let self = this;
      axios({
        method: "get",
        url: "/reagent_type/all"
      }).then(res => {
        if (res) {
          self.reagent_type = res.data.data;
        }
      });
    },
    tasdiqlash() {
      this.$emit("tasdiqlash", this.madalData);
      // console.log(this.registration_drug)
      this.$bvModal.hide("modal-tekshiruvlar");
      this.madalData = [];
    },
    Close() {
      this.madalData = [];
      this.$bvModal.hide("modal-tekshiruvlar");
    },
    deleteDrug(item, index) {
      this.$emit("delete_drug", item, index);
      // let ind = this.registration_drug.findIndex(x => x.key == item.key);
      // this.registration_drug.splice(ind, 1);
    },
    madalDataAdd() {
      const currentDate = new Date();

      const day = currentDate
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const year = currentDate.getFullYear().toString();
      const formattedDate = `${year}-${month}-${day}`;
      this.madalData.push({
        reagent: "",
        date: formattedDate,
        day: 0,
        time: 0,
        count: 1,
        ost: 0,
        price: 0,
        backlog: 0,
        discount: 0,
        pay_summa: 0,
        comment: "",
        user_id: null,
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        date_time: Math.floor(new Date().getTime() / 1000),
        reagent_type_id: null,
        reagent_type: this.reagent_type[0]
      });
    },
    removeRow(index) {
      this.madalData.splice(index, 1);
    },
    addRow() {
      const newRow = {};
      this.trDatas.push(newRow);
    },
    addColumn() {
      const newColumn = {};
      this.days.push(newColumn);
    },
    pechat() {
      let t = {};
      t = {
        data: {
          drug: this.registration_drug,
          trDatas: this.trDatas,
          days: this.days
        },
        bemor: this.$store.state.bemor
      };
      localStorage.setItem("muolaja", JSON.stringify(t));
      const rout = this.$router.resolve({
        path: "/user-muolaja"
      });
      window.open(rout.href, "_blank");
    },
    getReagent() {
      let self = this;
      axios({
        method: "post",
        url: "/reagent/all",
        data: { type: "pill" }
      }).then(res => {
        if (res.data.error == false) {
          self.reagentList = res.data.data;
        }
      });
    }
  }
};
</script>
<style>
.dori-add-btn-muolaja {
  position: absolute;
  z-index: 2;
  top: 3px;
  left: calc(100% - 70px);
  color: #b1b1b1;
  font-weight: 700;
  font-size: 17px;
  border: none;
  background-color: white;
}
.qoshish_Btn_ {
  position: relative;
  left: calc(100% - 40px);
  bottom: 0px;
  background: #195fb0;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #195fb0;
  box-shadow: 5px 8px 16px rgba(25, 95, 176, 0.5);
}
.card_month {
  transform: rotate(270deg);
  font-size: 11pt;
}
input[type="checkbox"] {
  transform: scale(1.5);
  margin: 5px;
}
</style>
